
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Simple fallback resources to prevent loading errors
const resources = {
  en: {
    translation: {
      loading: 'Loading...',
      error: 'Error',
      welcome: 'Welcome'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
